module.exports = __webpack_public_path__ + "media/images/photos/14-53176fcef7ace8fb96c33b2050f341d2.jpg";